import type { TFunction } from 'i18next';
import type { OrgRole } from '@/stores/orgStore';

export function orgRoleLabel(t: TFunction<'organization'>, role: OrgRole): string {
  return t(`roles.${String(role).toLowerCase()}`, { defaultValue: String(role) });
}

/** Legacy English job-function titles from demo seed / older defaults. */
const LEGACY_JOB_FUNCTION_KEYS: Record<string, string> = {
  'Sales Director': 'job_functions.sales_director',
  'Sales Manager': 'job_functions.sales_manager',
  'Sales Representative': 'job_functions.sales_representative',
  Analyst: 'job_functions.analyst',
  Finance: 'job_functions.finance',
};

export function formatJobFunction(
  value: string | null | undefined,
  t: TFunction<'organization'>,
): string | null {
  if (!value?.trim()) return null;
  const presetKey = LEGACY_JOB_FUNCTION_KEYS[value.trim()];
  return presetKey ? t(presetKey) : value.trim();
}
